import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmCloseDialogComponent } from 'src/app/modules/shared/dialogs/confirm-close-dialog';

@Component({
  selector: 'participants-form-app',
  templateUrl: 'participants-form.component.html',
  styleUrls: ['./participants-form.component.scss'],
})
export class ParticipantsFormComponent {
    participants: any[] = [];
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<ParticipantsFormComponent>,
    ) {
        this.data;
        this.participants =
            this.data.participants?.map((item: any) => {
                return {
                    name: item.name,
                    avatar: item.avatar,
                    email: item.email,
                };
            }) ?? [];
    }

    onCloseModal() {
        const confirmCloseDialog = this.dialog.open(ConfirmCloseDialogComponent, {
            width: '400px',
            height: '250px',
            position: {
                top: '78px',
            },
            panelClass: 'position-relative',
        });

        confirmCloseDialog.afterClosed().subscribe(data => {
            if (data == 'OK') {
                this.dialogRef.close();
            }
        });
    }
}
